var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filterbox",attrs:{"data-aos":"fade-in-right"}},[_c('p',{staticClass:"closebtn"},[_c('CloseIcon',{staticClass:"CloseIcon",on:{"click":_vm.ExitFilter}})],1),_c('IndusturyFilter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }